const colors = {
  red: "#CF3238",
  blue: "#03a9f4",
  gray: "#F4F4F4",
  teal: "#3ad0c3",
  dark: "#1F1F1F",
}

module.exports = colors
